import React from "react";

const ProgressBar = ({ currentStep, totalSteps }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="w-full mb-8">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-light text-muted-foreground">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-sm font-light text-brand">
          {Math.round(progress)}% Complete
        </span>
      </div>
      <div className="w-full bg-card border border-border rounded-full h-2">
        <div
          className="bg-brand h-2 rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
